import { useTranslation } from 'react-i18next';

import { IconButton, Tooltip } from '@treezor/design-system';

import { IDetailDialogProps } from '../DetailDialog';

import { useAppDispatch } from '@/hooks/redux-helpers';

import { openModal } from '@/store/actions/core.actions';

import { IBulkCard } from '@/features/cards/store/models/bulk-card.model';

interface IActionsColumnProps {
  bulkCardCreation: IBulkCard;
}

export const DetailAction = ({ bulkCardCreation }: IActionsColumnProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const toggleDetailDialog = () =>
    dispatch(openModal<IDetailDialogProps>('detailDialogBulk', { bulkCardCreation }, { maxWidth: 'xl' }));

  return (
    <Tooltip
      messageContent={t('pages.administration.bulkCards.creationDetails.creationDetailTitle')}
      placement="top"
      contentClassName="w-[100px]"
    >
      <IconButton
        icon="info"
        onClick={toggleDetailDialog}
        variant="tertiary"
        data-testid={`${bulkCardCreation.orderId}-details`}
      />
    </Tooltip>
  );
};
